const individualSubmitParser = ({ values, documents }) => {
  return {
    authorised_financier_user_attributes: {
      person_attributes: {
        user_attributes: {
          full_name: values?.fullName,
          email: values?.email,
          phone: values?.mobile,
          country_code: '+91',
        },
        person_kyc_attributes: {
          permanent_account_number: values?.pan,
          date_of_birth: values?.dob,
          aadhaar_number: values?.aadhaar,
          e_aadhaar_password: values?.aadhaarPassword,
        },
      },
    },
    documents: {
      document_pan_card_id: documents?.panDocument?.id,
      document_aadhaar_card_id: documents?.aadhaarDocument?.id,
      document_gstn_id: documents?.gstnDocument?.id,
    },
    financier_type: 'individual',
    referrer_code: values?.referralCode,
    has_gstn: values?.hasGSTN,
    gst_number: values?.gstn,
    address: values?.address,
    location: values?.location,
    pin_code: values?.pincode,
    agreed_to_terms_and_conditions: values?.termsAndConditions,
    optin_all_communications: values?.optinCommunication,
  }
}

const nriSubmitParser = ({ values, documents }) => {
  return {
    authorised_financier_user_attributes: {
      person_attributes: {
        user_attributes: {
          full_name: values?.fullName,
          email: values?.email,
          phone: values?.mobile,
          country_code: values?.countryCode,
        },
        person_kyc_attributes: {
          permanent_account_number: values?.pan,
          date_of_birth: values?.dob,
        },
      },
    },
    documents: {
      document_pan_card_id: documents?.panDocument?.id,
      document_nri_proof_id: documents?.nroDocument?.id,
      document_phone_bill_id: documents?.phoneBillDocument?.id,
      document_gstn_id: documents?.gstnDocument?.id,
    },
    financier_type: 'nri',
    referrer_code: values?.referralCode,
    has_gstn: values?.hasGSTN,
    gst_number: values?.gstn,
    address: values?.address,
    location: values?.location,
    pin_code: values?.pincode,
    agreed_to_terms_and_conditions: values?.termsAndConditions,
    optin_all_communications: values?.optinCommunication,
  }
}

const hufSubmitParser = ({ values, documents }) => {
  return {
    organisation_attributes: {
      name: values?.entityName,
      date_of_incorporation: values?.dof,
      organisation_kyc_attributes: {
        permanent_account_number: values?.entityPan,
        gst_number: values?.gstn,
      },
    },
    authorised_financier_user_attributes: {
      person_attributes: {
        user_attributes: {
          full_name: values?.fullName,
          email: values?.email,
          phone: values?.mobile,
          country_code: '+91',
        },
        person_kyc_attributes: {
          permanent_account_number: values?.pan,
          date_of_birth: values?.dob,
          aadhaar_number: values?.aadhaar,
          e_aadhaar_password: values?.aadhaarPassword,
        },
      },
    },
    documents: {
      organisation_document_pan_card_id: documents?.entityPanDocument?.id,
      organisation_document_gstn_id: documents?.gstnDocument?.id,
      document_pan_card_id: documents?.panDocument?.id,
      document_aadhaar_card_id: documents?.aadhaarDocument?.id,
    },
    financier_type: 'huf',
    referrer_code: values?.referralCode,
    has_gstn: values?.hasGSTN,
    address: values?.address,
    location: values?.location,
    pin_code: values?.pincode,
    agreed_to_terms_and_conditions: values?.termsAndConditions,
    optin_all_communications: values?.optinCommunication,
  }
}

const llpSubmitParser = ({ values, documents }) => {
  return {
    organisation_attributes: {
      name: values?.entityName,
      date_of_incorporation: values?.dof,
      organisation_kyc_attributes: {
        permanent_account_number: values?.entityPan,
        gst_number: values?.gstn,
      },
    },
    authorised_financier_user_attributes: {
      person_attributes: {
        user_attributes: {
          full_name: values?.fullName,
          email: values?.email,
          phone: values?.mobile,
          country_code: '+91',
        },
        person_kyc_attributes: {
          permanent_account_number: values?.pan,
          date_of_birth: values?.dob,
          aadhaar_number: values?.aadhaar,
          e_aadhaar_password: values?.aadhaarPassword,
        },
      },
    },
    documents: {
      organisation_document_pan_card_id: documents?.entityPanDocument?.id,
      organisation_document_gstn_id: documents?.gstnDocument?.id,
      document_pan_card_id: documents?.panDocument?.id,
      document_aadhaar_card_id: documents?.aadhaarDocument?.id,
      organisation_partnership_deed_id: documents?.partnershipDocument?.id,
      organisation_certificate_of_incorporation_id: documents?.registrationDocument?.id,
      organisation_annexure_a_id: documents?.resolutionDocument?.id,
    },
    financier_type: 'llp',
    referrer_code: values?.referralCode,
    has_gstn: values?.hasGSTN,
    address: values?.address,
    location: values?.location,
    pin_code: values?.pincode,
    agreed_to_terms_and_conditions: values?.termsAndConditions,
    optin_all_communications: values?.optinCommunication,
  }
}

const companySubmitParser = ({ values, documents }) => {
  return {
    organisation_attributes: {
      name: values?.entityName,
      date_of_incorporation: values?.dof,
      organisation_kyc_attributes: {
        permanent_account_number: values?.entityPan,
        gst_number: values?.gstn,
      },
    },
    authorised_financier_user_attributes: {
      person_attributes: {
        user_attributes: {
          full_name: values?.fullName,
          email: values?.email,
          phone: values?.mobile,
          country_code: '+91',
        },
        person_kyc_attributes: {
          permanent_account_number: values?.pan,
          date_of_birth: values?.dob,
          aadhaar_number: values?.aadhaar,
          e_aadhaar_password: values?.aadhaarPassword,
        },
      },
    },
    documents: {
      organisation_document_pan_card_id: documents?.entityPanDocument?.id,
      organisation_document_gstn_id: documents?.gstnDocument?.id,
      document_pan_card_id: documents?.panDocument?.id,
      document_aadhaar_card_id: documents?.aadhaarDocument?.id,
      organisation_certificate_of_incorporation_id: documents?.registrationDocument?.id,
      organisation_annexure_a_id: documents?.resolutionDocument?.id,
    },
    financier_type: 'company',
    referrer_code: values?.referralCode,
    has_gstn: values?.hasGSTN,
    address: values?.address,
    location: values?.location,
    pin_code: values?.pincode,
    agreed_to_terms_and_conditions: values?.termsAndConditions,
    optin_all_communications: values?.optinCommunication,
  }
}

export const registerSubmitParsers = (type, data) => {
  switch (type) {
    case 'individual':
      return individualSubmitParser(data)
    case 'nri':
      return nriSubmitParser(data)
    case 'huf':
      return hufSubmitParser(data)
    case 'llp':
      return llpSubmitParser(data)
    case 'company':
      return companySubmitParser(data)
    default:
      break
  }
}
